import {
  ASSET_LIST, ASSET_LIST_SUCCESS, ASSET_LIST_FAILURE,
  ASSET_DATA, ASSET_DATA_SUCCESS, ASSET_DATA_FAILURE,
  ASSET_CREATE, ASSET_CREATE_SUCCESS, ASSET_CREATE_FAILURE,
  ASSET_UPDATE, ASSET_UPDATE_SUCCESS, ASSET_UPDATE_FAILURE,
  ASSET_DELETE, ASSET_DELETE_SUCCESS, ASSET_DELETE_FAILURE,
  ASSET_BULK_ASSIGN, ASSET_BULK_ASSIGN_SUCCESS, ASSET_BULK_ASSIGN_FAILURE,
  ASSET_NOTE_LIST, ASSET_NOTE_LIST_SUCCESS, ASSET_NOTE_LIST_FAILURE,
  ASSET_NOTE_CREATE, ASSET_NOTE_CREATE_SUCCESS, ASSET_NOTE_CREATE_FAILURE,
  ASSET_NOTE_UPDATE, ASSET_NOTE_UPDATE_SUCCESS, ASSET_NOTE_UPDATE_FAILURE,
  ASSET_NOTE_DELETE, ASSET_NOTE_DELETE_SUCCESS, ASSET_NOTE_DELETE_FAILURE,
  ASSET_ATTACHMENT_SEARCH, ASSET_ATTACHMENT_SEARCH_SUCCESS, ASSET_ATTACHMENT_SEARCH_FAILURE,
  ASSET_ATTACHMENT_DELETE, ASSET_ATTACHMENT_DELETE_SUCCESS, ASSET_ATTACHMENT_DELETE_FAILURE,
  ASSET_RECENT_ACTIVITY_LIST, ASSET_RECENT_ACTIVITY_LIST_SUCCESS, ASSET_RECENT_ACTIVITY_LIST_FAILURE,
  ASSET_DIARY_SLOT_LIST, ASSET_DIARY_SLOT_LIST_SUCCESS, ASSET_DIARY_SLOT_LIST_FAILURE,
} from "./actionType";

export const assetList = () => ({ type: ASSET_LIST });
export const assetListSuccess = (data) => ({ type: ASSET_LIST_SUCCESS, payload: data });
export const assetListFailure = (error) => ({ type: ASSET_LIST_FAILURE, payload: error });

export const assetData = (data) => ({ type: ASSET_DATA, payload: data });
export const assetDataSuccess = (data) => ({ type: ASSET_DATA_SUCCESS, payload: data });
export const assetDataFailure = (error) => ({ type: ASSET_DATA_FAILURE, payload: error });

export const assetCreate = (data) => ({ type: ASSET_CREATE, payload: data });
export const assetCreateSuccess = (data) => ({ type: ASSET_CREATE_SUCCESS, payload: data });
export const assetCreateFailure = (error) => ({ type: ASSET_CREATE_FAILURE, payload: error });

export const assetUpdate = (data) => ({ type: ASSET_UPDATE, payload: data });
export const assetUpdateSuccess = (data) => ({ type: ASSET_UPDATE_SUCCESS, payload: data });
export const assetUpdateFailure = (error) => ({ type: ASSET_UPDATE_FAILURE, payload: error });

export const assetDelete = (data) => ({ type: ASSET_DELETE, payload: data });
export const assetDeleteSuccess = (data) => ({ type: ASSET_DELETE_SUCCESS, payload: data });
export const assetDeleteFailure = (error) => ({ type: ASSET_DELETE_FAILURE, payload: error });

export const assetBulkAssign = (data) => ({ type: ASSET_BULK_ASSIGN, payload: data });
export const assetBulkAssignSuccess = (data) => ({ type: ASSET_BULK_ASSIGN_SUCCESS, payload: data });
export const assetBulkAssignFailure = (error) => ({ type: ASSET_BULK_ASSIGN_FAILURE, payload: error });

export const assetNoteList = (data) => ({ type: ASSET_NOTE_LIST, payload: data });
export const assetNoteListSuccess = (data) => ({ type: ASSET_NOTE_LIST_SUCCESS, payload: data });
export const assetNoteListFailure = (error) => ({ type: ASSET_NOTE_LIST_FAILURE, payload: error });

export const assetNoteCreate = (data) => ({ type: ASSET_NOTE_CREATE, payload: data });
export const assetNoteCreateSuccess = (data) => ({ type: ASSET_NOTE_CREATE_SUCCESS, payload: data });
export const assetNoteCreateFailure = (error) => ({ type: ASSET_NOTE_CREATE_FAILURE, payload: error });

export const assetNoteUpdate = (data) => ({ type: ASSET_NOTE_UPDATE, payload: data });
export const assetNoteUpdateSuccess = (data) => ({ type: ASSET_NOTE_UPDATE_SUCCESS, payload: data });
export const assetNoteUpdateFailure = (error) => ({ type: ASSET_NOTE_UPDATE_FAILURE, payload: error });

export const assetNoteDelete = (data) => ({ type: ASSET_NOTE_DELETE, payload: data });
export const assetNoteDeleteSuccess = (data) => ({ type: ASSET_NOTE_DELETE_SUCCESS, payload: data });
export const assetNoteDeleteFailure = (error) => ({ type: ASSET_NOTE_DELETE_FAILURE, payload: error });

export const assetAttachmentSearch = (data) => ({ type: ASSET_ATTACHMENT_SEARCH, payload: data });
export const assetAttachmentSearchSuccess = (data) => ({ type: ASSET_ATTACHMENT_SEARCH_SUCCESS, payload: data });
export const assetAttachmentSearchFailure = (error) => ({ type: ASSET_ATTACHMENT_SEARCH_FAILURE, payload: error });

export const assetAttachmentDelete = (data) => ({ type: ASSET_ATTACHMENT_DELETE, payload: data });
export const assetAttachmentDeleteSuccess = (data) => ({ type: ASSET_ATTACHMENT_DELETE_SUCCESS, payload: data });
export const assetAttachmentDeleteFailure = (error) => ({ type: ASSET_ATTACHMENT_DELETE_FAILURE, payload: error });

export const assetRecentActivityList = (data) => ({ type: ASSET_RECENT_ACTIVITY_LIST, payload: data });
export const assetRecentActivityListSuccess = (data) => ({ type: ASSET_RECENT_ACTIVITY_LIST_SUCCESS, payload: data });
export const assetRecentActivityListFailure = (error) => ({ type: ASSET_RECENT_ACTIVITY_LIST_FAILURE, payload: error });

export const assetDiarySlotList = (data) => ({ type: ASSET_DIARY_SLOT_LIST, payload: data });
export const assetDiarySlotListSuccess = (data) => ({ type: ASSET_DIARY_SLOT_LIST_SUCCESS, payload: data });
export const assetDiarySlotListFailure = (error) => ({ type: ASSET_DIARY_SLOT_LIST_FAILURE, payload: error });
